import { IsString, IsNotEmpty, IsUUID } from 'class-validator';

import { NOT_EMPTY_OPTIONS } from '../../constants';

export class RetryEventDto {
  @IsUUID()
  @IsNotEmpty()
  eventId: string;

  @IsUUID()
  @IsNotEmpty(NOT_EMPTY_OPTIONS)
  nodeId: string;

  @IsString()
  @IsNotEmpty(NOT_EMPTY_OPTIONS)
  actionType: string;
}
